module.exports = " <div class=search_bar _v-34d15dcd=\"\"> <i class=material-icons _v-34d15dcd=\"\">search</i> <input @keyup=updateFilter _v-34d15dcd=\"\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-34d15dcd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/sidebar/SearchBar.vue
 ** module id = 342
 ** module chunks = 2
 **/